import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, InputNumber } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import CurrencyInput from "react-currency-input";
import { odata } from "../Filters/Helper";
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const StockUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });

  const [purchasePriceIncTaxes, setPurchasePriceIncTaxes] = useState(
    props.data.purchasePriceIncTaxes
  );
  const [sellingPriceIncTaxes, setSellingPriceIncTaxes] = useState(
    props.data.sellingPriceIncTaxes
  );
  const [purchasePriceExcTaxes, setPurchasePriceExcTaxes] = useState(
    props.data.purchasePriceExcTaxes
  );
  const [sellingPriceExcTaxes, setSellingPriceExcTaxes] = useState(
    props.data.sellingPriceExcTaxes
  );
  const [vatRate, setVatRate] = useState(props.data.vatRate);
  const [projectSelect, setProjectSelect] = useState({
    data: [],
    loading: false,
  });

  const [materialSelect, setMaterialSelect] = useState({
    data: [],
    loading: true,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
      if (props.data.materialId) {
        RequestHandler.get(`/MaterialCategory`).then((response) => {
          if (response) {
            setMaterialSelect({
              data: response.value,
              loading: false,
            });
          }
        });
      }
    }
    getCurrencies();
  }, [props.data]);

  const onFinish = (values) => {
    RequestHandler.put(`/Stock`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        form.resetFields();
        if (props.onSuccess) props.onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetFilterCurrency`).then((response) => {
      setCurrencySelect({
        data: response,
        loading: false,
      });
    });
  };

  const onMaterialSeach = (value) => {
    if (value.length >= 2) {
      setMaterialSelect({ data: [], loading: true });

      RequestHandler.get(
        `/MaterialCategory?$select=id,code,name,totalName&$filter=(${odata.contains(
          "totalName",
          value
        )} or ${odata.contains("code", value)}) and Name ne 'Diğer'`
      ).then((res) => {
        setMaterialSelect({ data: res.value, loading: false });
      });
    } else {
      setMaterialSelect({ data: [], loading: false });
    }
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="stockAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            label="Ürün Adı"
            name="name"
            rules={[
              { required: true, message: "Lütfen Ürün adını boş bırakmayın." },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Stok Kodu"
            name="stockCode"
            rules={[
              {
                required: true,
                message: "Lütfen Stok Kodu'nu boş bırakmayın.",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Güncel Stok"
            name="count"
            rules={[
              {
                required: true,
                message: "Lütfen Güncel Stok giriniz.",
              },
            ]}
          >
            <InputNumber
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              // onChange={(value, name) => {
              //   console.log(name);
              //   form.setFieldsValue({
              //     count: name,
              //   });
              // }}
              precision={2}
              placeholder="0,00"
            />
          </Form.Item>

          <Form.Item
            label="Stok Birimi"
            name="unit"
            rules={[{ required: true, message: "Lütfen Stok Birimi giriniz." }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="currencyCode"
            label="Para Birimi"
            rules={[
              { required: true, message: "Lütfen Para Birimi seçiniz.." },
            ]}
          >
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={currencySelect.loading}
            >
              {currencySelect.data.map(({ text, value }) => (
                <Select.Option key={text} value={text}>
                  {value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="transactionProjectTypeId" label="Ana Depo :">
            <Select
              disabled={true}
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                option.code
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={projectSelect.loading}
            >
              <Select.Option
                key={props?.data?.transactionProjectTypeId}
                value={props?.data?.transactionProjectTypeId}
                code={props?.data?.transactionProjectName}
              >
                {props?.data?.transactionProjectName}
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="materialCategoryId" label="Kategori :">
            <Select
              allowClear
              showSearch
              placeholder="En az 2 harf giriniz.."
              onSearch={onMaterialSeach}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                option.code
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={materialSelect.loading}
            >
              {materialSelect.data.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  code={item.firmBranchNumber}
                >
                  {item.totalName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {/* <Form.Item label="Raf No" name="shelfNo">
            <Input />
          </Form.Item>
          <Form.Item label="Palet No" name="palletNo">
            <Input />
          </Form.Item>
          <Form.Item label="Kap No" name="containerNo">
            <Input />
          </Form.Item>
          <Form.Item label="İstasyon No" name="stationNo">
            <Input />
          </Form.Item> */}

          <Form.Item label="KDV Oranı" name="vatRate">
            <Select
              allowClear
              showSearch
              onChange={(value) => {
                form.setFieldsValue({
                  purchasePriceIncTaxes: Math.abs(
                    (purchasePriceExcTaxes * value) / 100 +
                      Math.abs(purchasePriceExcTaxes)
                  ),
                  sellingPriceIncTaxes: Math.abs(
                    (sellingPriceExcTaxes * value) / 100 +
                      Math.abs(sellingPriceExcTaxes)
                  ),
                });
                setVatRate(value);
              }}
            >
              <Select.Option key={1} value={1}>
                %1
              </Select.Option>
              <Select.Option key={10} value={10}>
                %10
              </Select.Option>
              <Select.Option key={20} value={20}>
                %20
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Tevkifat (%)" name="taxRate">
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  taxRate: name,
                });
              }}
            />
          </Form.Item>

          <Form.Item label="Vergisiz Alış Fiyatı" name="purchasePriceExcTaxes">
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  purchasePriceIncTaxes: Math.abs(
                    (name * vatRate) / 100 + name
                  ),
                  purchasePriceExcTaxes: name,
                });
                setPurchasePriceExcTaxes(
                  parseFloat(name.toString()).toFixed(2)
                );
              }}
            />
          </Form.Item>
          {/* <Form.Item label="Vergisiz Satış Fiyatı" name="sellingPriceExcTaxes">
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  sellingPriceIncTaxes: Math.abs((name * vatRate) / 100 + name),
                  sellingPriceExcTaxes: name,
                });
                setSellingPriceExcTaxes(parseFloat(name.toString()).toFixed(2));
              }}
            />
          </Form.Item> */}
          <Form.Item
            label="Vergiler Dahil Alış Fiyatı"
            name="purchasePriceIncTaxes"
          >
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  purchasePriceExcTaxes: Math.abs(
                    (name / (100 + vatRate)) * 100
                  ),
                  purchasePriceIncTaxes: name,
                });
                setPurchasePriceExcTaxes(
                  Math.abs((name / (100 + vatRate)) * 100)
                );
                setPurchasePriceIncTaxes(
                  parseFloat(name.toString()).toFixed(2)
                );
              }}
            />
          </Form.Item>
          {/* <Form.Item
            label="Vergiler Dahil Satış Fiyatı"
            name="sellingPriceIncTaxes"
          >
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  sellingPriceExcTaxes: Math.abs(
                    (name / (100 + vatRate)) * 100
                  ),
                  sellingPriceIncTaxes: name,
                });
                setSellingPriceExcTaxes(
                  Math.abs((name / (100 + vatRate)) * 100)
                );
                setSellingPriceIncTaxes(parseFloat(name.toString()).toFixed(2));
              }}
            />
          </Form.Item> */}

          <Form.Item label="Açıklama" name="description">
            <TextArea rows={4} />
          </Form.Item>

          <Row justify="space-between">
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default StockUpdateForm;
